import * as React from 'react';
import { forwardRef } from 'react';

export type DMTextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const DMTextarea = forwardRef<HTMLTextAreaElement, DMTextareaProps>(
  ({ className = '', ...props }, ref) => {
    return <textarea ref={ref} className={className} {...props} />;
  }
);
DMTextarea.displayName = 'DMTextarea';
